import React from 'react';
import Sidebar from '../components/common/Sidebar';
import { Outlet, useNavigation } from 'react-router-dom';
import ProgressOverlay from 'components/ProgressOverlay';
import CameraOverlay from 'components/CameraOverlay';
import ShopperAvailabilityOverlay from 'components/ShopperAvailabilityOverlay';
import { useOrder } from 'context/OrderContext';
import ScrollToTop from '../components/ScrollToTop';

const DesktopLayout = () => {
	const { orderDetails } = useOrder();

	return (
		<div className='flex'>
			<Sidebar />
			<main className='relative max-w-4xl xl:max-w-2xl md:max-w-lg lg:max-w-xl mx-auto bg-gray-50 grow'>
				<ScrollToTop />
				<Outlet />
				{orderDetails && <ProgressOverlay />}
				<ShopperAvailabilityOverlay />
				<CameraOverlay />
			</main>
		</div>
	);
};

export default DesktopLayout;
